import "../../sass/layout/portalAdmininistration/portalAdministration.css";
import "../../sass/retireeContacts.css";
import { Container, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { fetchMIIAContacts } from "./../../services/actions/users.action";
import ContactList from "./contactList";
import MenuPath from "../path/MenuPath";
import TitlePage from "../titlePage";
import Paginator from '../paginator/paginator';
import usePagination from '../../hooks/usePagination';
import UserService from "../../services/api/UserService";
import { useMemo } from "react";

const ContactMIIAteams = () => {
  const { t } = useTranslation();
  const isLoggedIn = useMemo(() => UserService.isLoggedIn(), []);
  
  const contacts = useSelector(
    (state) => state.usersReducer.miiaContacts?.data
  );
  const meta = useSelector(
    (state) => state.usersReducer.miiaContacts?.meta
  );
  const { items, paginationParams, onClickPage } = usePagination(
    isLoggedIn ? fetchMIIAContacts : () => {}, 
    meta
  );

  const displayContacts = contacts;
  const hasContacts = displayContacts && displayContacts.length > 0;

  return (
      <div>
        <Row >
          <MenuPath className="menuPathPortalAdmin" name={t("contact.link")} />
        </Row>
        <Row className="box-menu-retiree">
          <TitlePage boldText={t("contact.title")} commonText={""} />
        </Row>
        <Row>
          <Col className="box-portal-admin">
            {isLoggedIn ? (
              <>
                {hasContacts ? (
                  <ContactList prop={displayContacts} />
                ) : (
                  <h4 className="portalAdmin-title">
                    {t("portalAdministration.noContact")}
                  </h4>
                )}
                <Container fluid className="pagination-contacts">
                  <Paginator
                    items={items}
                    onClickPage={onClickPage}
                    filterParams={paginationParams}
                    metadata={meta}
                  />
                </Container>
              </>
            ) : (
              <div className="retiree-contacts-container">
                <div className="retiree-contacts-grid">
                  <div className="retiree-contact-card">
                    <p className="retiree-contact-description">
                      {t("contact.healthCoverageText")} <span className="retiree-contact-organization">{t("contact.healthCoverageOrg")}</span>:
                    </p>
                    <p className="retiree-contact-info">
                      <a href="tel:1-800-782-3675" className="retiree-contact-link">1-800-782-3675</a>
                    </p>
                  </div>

                  <div className="retiree-contact-card">
                    <p className="retiree-contact-description">
                      {t("contact.prescriptionText")} <span className="retiree-contact-organization">{t("contact.prescriptionOrg")}</span>:
                    </p>
                    <p className="retiree-contact-info">
                      <a href="tel:1-888-543-4917" className="retiree-contact-link">1-888-543-4917</a>
                    </p>
                  </div>

                  <div className="retiree-contact-card">
                    <p className="retiree-contact-description">
                      {t("contact.miiaTeamText")} <span className="retiree-contact-organization">{t("contact.miiaTeamOrg")}</span>{t("contact.endOfParagraph")}:
                    </p>
                    <p className="retiree-contact-info">
                      <a href="mailto:miia.retiree.team@mma.org" className="retiree-contact-link">miia.retiree.team@mma.org</a>
                    </p>
                  </div>
                </div>
              </div>
            )}
          </Col>
        </Row>
      </div>
  );
};

export default ContactMIIAteams;
